import type { ChatWidgetTranslation } from './types';

export const chatWidgetHi: ChatWidgetTranslation = {
  nav: 'चैट विजेट',
  title: 'चैट विजेट',
  description:
    'आपकी वेबसाइट पर चैट कैसी दिखती और काम करती है, ग्राहकों से क्या पूछती है, और उसे कैसे साझा करें। हर टैब अलग से सेव होता है, और बदलाव एक मिनट में वेबसाइटों तक पहुँचते हैं।',
  loading: 'चैट विजेट की सेटिंग लोड हो रही हैं',
  brand: 'ब्रांड',
  open: 'चैट विजेट',
  openLabel: '{{name}} के लिए चैट विजेट सेटिंग',
  noPermission: 'आपकी भूमिका चैट विजेट नहीं बदल सकती। वर्कस्पेस के मालिक या एडमिन से कहें।',
  forbidden: {
    title: 'आप चैट विजेट नहीं बदल सकते',
    description: 'वर्कस्पेस के मालिक या एडमिन से ऐसी भूमिका माँगें जो चैट विजेट सेट कर सके।',
  },
  noBrands: {
    title: 'अभी कोई ब्रांड नहीं है',
    description: 'पहले एक ब्रांड और उसकी वेबसाइट जोड़ें। फिर यहाँ उसकी चैट सेट करें।',
    action: 'ब्रांड और इंस्टॉल पर जाएँ',
  },
  tabs: {
    label: 'चैट के हिस्से',
    look: 'रूप',
    behaviour: 'व्यवहार',
    forms: 'फ़ॉर्म',
    privacy: 'गोपनीयता',
    share: 'साझा करें',
  },
  unsaved: 'आपके कुछ बदलाव सेव नहीं हुए हैं।',
  reset: 'बदलाव वापस लें',
  guideLook: 'रूप कैसे बदलें',
  preview: {
    note: 'सेव करने से पहले, आपके बदलावों के साथ चैट की एक तस्वीर। असली चैट आज़माने के लिए, ब्रांड और इंस्टॉल पर टेस्ट चैट इस्तेमाल करें।',
    language: 'भाषा',
    screen: 'दिखाएँ',
    screens: {
      prechat: 'चैट शुरू होने से पहले',
      offline: 'संपर्क फ़ॉर्म',
      thanks: 'भेजने के बाद',
    },
    prechatOff: 'चैट से पहले वाला फ़ॉर्म बंद है: ग्राहक सीधे चैट में जाते हैं।',
    offlineOff: 'संपर्क फ़ॉर्म बंद है: ग्राहक फिर भी लिख सकते हैं, और लौटने पर जवाब पढ़ सकते हैं।',
    consentOff: 'सहमति बंद है: चैट से पहले किसी से सहमति नहीं माँगी जाती।',
    layout: 'आपकी वेबसाइट पर: {{layout}}, {{side}}।',
  },
  behaviour: {
    title: 'चैट कैसे काम करती है',
    description: 'चैट कहाँ दिखती है, ग्राहक क्या भेज और ढूँढ सकते हैं, और उन्हें कौन से ईमेल मिलते हैं।',
  },
  forms: {
    guide: 'फ़ॉर्म कैसे काम करते हैं',
    save: 'फ़ॉर्म सेव करें',
    saved: '{{name}} के फ़ॉर्म सेव हो गए। एक मिनट में वेबसाइटों पर दिखेंगे।',
    prechat: {
      title: 'चैट शुरू होने से पहले',
      description:
        'चैट शुरू होने से पहले कुछ बातें पूछें, ताकि सही व्यक्ति ज़रूरी जानकारी के साथ जवाब दे। हर अतिरिक्त सवाल का मतलब है कि कम ग्राहक चैट शुरू करेंगे।',
      enabled: 'चैट शुरू होने से पहले ये सवाल पूछें',
      enabledHint: 'बंद होने पर, ग्राहक सीधे लिखना शुरू करते हैं।',
      skipVerified: 'जिन ग्राहकों को आपकी वेबसाइट ने साइन इन किया है, उनके लिए सवाल छोड़ दें',
      skipVerifiedHint: 'आपकी वेबसाइट ने पहले ही बता दिया है कि वे कौन हैं, इसलिए वे सीधे चैट में जाते हैं।',
    },
    offline: {
      title: 'जब कोई जवाब देने के लिए न हो',
      description:
        'इंतज़ार करने के बजाय, ग्राहक एक संदेश छोड़ते हैं। वह इनबॉक्स में एक टिकट बन जाता है, और पता पक्का होने के बाद जवाब उनके ईमेल पर जाता है।',
      enabled: 'जब कोई जवाब न दे सके, तब संपर्क फ़ॉर्म दिखाएँ',
      enabledHint: 'बंद होने पर भी ग्राहक चैट में लिख सकते हैं और लौटने पर जवाब पढ़ सकते हैं।',
      when: 'कब दिखाएँ',
      whens: {
        either: 'कामकाज के घंटों के बाहर, या जब कोई ऑनलाइन न हो',
        eitherHint: 'ग्राहक कभी यह जाने बिना इंतज़ार नहीं करते कि कोई मौजूद नहीं है।',
        closed: 'सिर्फ़ कामकाज के घंटों के बाहर',
        closedHint: 'इसके लिए कामकाज के घंटे चाहिए। उनके बिना फ़ॉर्म कभी नहीं दिखता।',
        nobody_online: 'सिर्फ़ तब जब टीम में कोई ऑनलाइन न हो',
        nobody_onlineHint: 'कामकाज के घंटों में भी, जब सभी दूर या ऑफ़लाइन हों।',
      },
      thanks: 'धन्यवाद संदेश',
      thanksHint:
        'भेजने के बाद ग्राहक क्या पढ़ते हैं। खाली छोड़ने पर Hamnivo के अपने शब्द इस्तेमाल होते हैं (हल्के रंग में दिखते हैं)। जब तक आप दूसरी भाषाओं में न लिखें, वे अंग्रेज़ी दिखाती हैं।',
      aiFirst: 'पहले एआई सहायक को जवाब देने दें',
      aiFirstHint: 'एआई सहायक संदेश का जवाब देने की कोशिश करता है। टिकट सौंपने पर लोग आगे संभालते हैं।',
      emailLocked: 'हमेशा पूछा जाता है और ज़रूरी है: जवाब ग्राहक को इसी पते पर मिलता है।',
      questionLocked: 'हमेशा पूछा जाता है और ज़रूरी है: आपकी टीम इसी का जवाब देती है।',
      lockedRemove: 'इस सवाल के बिना संपर्क फ़ॉर्म काम नहीं कर सकता।',
    },
    fields: {
      legend: 'सवाल',
      count: '{{max}} में से {{n}} सवाल',
      empty: 'अभी कोई सवाल नहीं है। एक जोड़ें, या यह फ़ॉर्म बंद करें।',
      field: 'सवाल {{number}}: {{name}}',
      kind: 'जवाब का प्रकार',
      kinds: {
        name: 'नाम',
        email: 'ईमेल पता',
        phone: 'फ़ोन नंबर',
        question: 'उनका सवाल',
        department: 'किस टीम से बात करनी है',
        text: 'छोटा जवाब',
        choice: 'सूची में से चुनें',
      },
      label: 'ग्राहक क्या पढ़ता है',
      labelHint: 'अंग्रेज़ी ज़रूरी है। जब तक आप दूसरी भाषाओं में न लिखें, वे अंग्रेज़ी दिखाती हैं।',
      required: 'ग्राहकों को इसका जवाब देना होगा',
      moveUp: '{{name}} को ऊपर ले जाएँ',
      moveDown: '{{name}} को नीचे ले जाएँ',
      moved: '{{name}} अब सवाल {{number}} है।',
      remove: '{{name}} हटाएँ',
      removeShort: 'हटाएँ',
      removed: '{{name}} हटा दिया गया।',
      add: 'सवाल जोड़ें',
      added: '{{name}} आख़िर में जोड़ दिया गया।',
      full: 'एक फ़ॉर्म ज़्यादा से ज़्यादा {{max}} सवाल पूछ सकता है। दूसरा जोड़ने के लिए एक हटाएँ।',
      options: 'चुनने के लिए जवाब',
      optionsHint: '{{min}} से {{max}} जवाब।',
      departmentHint: 'हर जवाब बातचीत को एक सपोर्ट टीम के पास भेजता है।',
      option: 'जवाब {{number}}',
      team: 'जवाब {{number}} की टीम',
      teamPlaceholder: 'टीम चुनें',
      noTeams: 'पहले एक सपोर्ट टीम जोड़ें: हर जवाब किसी टीम तक जाता है।',
      noTeamsLink: 'सपोर्ट टीमों पर जाएँ',
      addOption: 'जवाब जोड़ें',
      removeOption: '{{name}} का जवाब {{number}} हटाएँ',
      otherLanguages: 'अरबी, हिंदी और उर्दू (3 में से {{n}} लिखी गईं)',
      optionsFull: 'एक सूची में ज़्यादा से ज़्यादा {{max}} जवाब हो सकते हैं।',
    },
    problems: {
      at: '{{form}}, सवाल {{number}}',
      label: '{{at}}: अंग्रेज़ी में लिखें कि सवाल में क्या लिखा है।',
      duplicateKind: '{{at}}: इस तरह का जवाब पहले से पूछा गया है। इसे एक ही बार पूछें।',
      fewOptions: '{{at}}: कम से कम {{min}} जवाब दें।',
      manyOptions: '{{at}}: ज़्यादा से ज़्यादा {{max}} जवाब दें।',
      optionLabel: '{{at}}: जवाब {{option}} अंग्रेज़ी में लिखें।',
      optionTeam: '{{at}}: जवाब {{option}} के लिए टीम चुनें।',
      tooManyFields: '{{form}}: ज़्यादा से ज़्यादा {{max}} सवाल पूछें।',
      needsEmail: 'संपर्क फ़ॉर्म में ज़रूरी ईमेल पता होना चाहिए, ताकि जवाब ग्राहक तक पहुँचे।',
      needsQuestion:
        'संपर्क फ़ॉर्म में ग्राहक का सवाल ज़रूरी होना चाहिए, ताकि आपकी टीम जाने कि क्या जवाब देना है।',
      thanksEnglish: 'पहले धन्यवाद संदेश अंग्रेज़ी में लिखें। दूसरी भाषाएँ उसी पर लौटती हैं।',
      forms: {
        prechat: 'चैट से पहले वाला फ़ॉर्म',
        offline: 'संपर्क फ़ॉर्म',
      },
    },
  },
  privacy: {
    title: 'चैट से पहले सहमति',
    description:
      'चैट शुरू होने से पहले ग्राहकों से सहमति माँगें। उनकी सहमति उन शब्दों के संस्करण के साथ रखी जाती है जिन पर वे सहमत हुए।',
    guide: 'सहमति कैसे काम करती है',
    mode: 'किससे पूछा जाए',
    modes: {
      off: 'किसी से नहीं',
      offHint: 'ग्राहक सीधे चैट शुरू करते हैं।',
      everyone: 'हर विज़िटर से',
      everyoneHint: 'हर कोई अपने पहले संदेश से पहले एक बार सहमति देता है।',
      eu: 'सिर्फ़ ईयू, ईईए और यूके के विज़िटर से',
      euHint: 'हर विज़िट पर हम देखते हैं कि कनेक्शन कहाँ से आ रहा है, और इसे कभी सेव नहीं करते।',
    },
    text: 'वे शब्द जिन पर ग्राहक सहमति देते हैं',
    textHint:
      'खाली छोड़ने पर Hamnivo के अपने शब्द इस्तेमाल होते हैं (हल्के रंग में दिखते हैं)। जब तक आप दूसरी भाषाओं में न लिखें, वे अंग्रेज़ी दिखाती हैं।',
    reconsent: 'शब्द बदलने पर, पहले सहमति दे चुके ग्राहकों से फिर से सहमति माँगी जाती है।',
    reconsentNow: 'आपने शब्द बदले हैं: सेव करने के बाद, पहले सहमति दे चुके ग्राहकों से फिर पूछा जाएगा।',
    version: 'ग्राहकों ने शब्दों के संस्करण {{version}} पर सहमति दी है।',
    versionNone: 'अभी तक किसी ने सहमति नहीं दी: ये शब्द सेव नहीं हुए हैं।',
    privacyLink: 'गोपनीयता नीति का लिंक',
    privacyLinkHint: 'सवाल के साथ दिखता है। इसे आप रूप टैब पर सेट करते हैं।',
    privacyNone: 'अभी गोपनीयता नीति का कोई लिंक नहीं है।',
    privacyEdit: 'इसे रूप टैब पर बदलें',
    save: 'सहमति की सेटिंग सेव करें',
    saved: '{{name}} की सहमति सेटिंग सेव हो गईं।',
    english: 'पहले शब्द अंग्रेज़ी में लिखें। दूसरी भाषाएँ उन्हीं पर लौटती हैं।',
  },
  share: {
    link: {
      title: 'सीधा चैट लिंक',
      description: 'एक पेज जिस पर सिर्फ़ चैट है, जिसे ईमेल, सोशल मीडिया या छपी चीज़ों में साझा किया जा सके।',
      guide: 'सीधा लिंक कैसे काम करता है',
      enabled: 'लोगों को लिंक से चैट खोलने दें',
      enabledHint: 'इसे बंद करने से लिंक से खोली गई चैट ख़त्म हो जाती हैं।',
      save: 'लिंक की सेटिंग सेव करें',
      savedOn: '{{name}} के लिए सीधा चैट लिंक चालू है।',
      savedOff: '{{name}} के लिए सीधा चैट लिंक बंद है।',
      url: 'चैट लिंक',
      copy: 'लिंक कॉपी करें',
      copied: 'लिंक कॉपी हो गया',
      copyFailed: 'कॉपी नहीं हो सका। लिंक चुना हुआ है: उसे ख़ुद कॉपी करें।',
      open: 'खोलें',
      openLabel: 'चैट लिंक नए टैब में खोलें',
      off: 'लिंक बंद है। लिंक और उसका क्यूआर कोड पाने के लिए इसे चालू करके सेव करें।',
      noUrl:
        'लिंक अभी नहीं बन सकता: इस सर्वर को चैट का वेब पता नहीं पता। अपना Hamnivo सर्वर चलाने वाले व्यक्ति से इसे सेट करने को कहें।',
      anyWebsite: 'लिंक उन वेबसाइटों पर भी काम करता है जो आपकी अनुमति वाली सूची में नहीं हैं।',
    },
    qr: {
      title: 'क्यूआर कोड',
      description: 'इसे रसीदों, पैकेजिंग या पोस्टरों पर छापें। फ़ोन का कैमरा चैट खोल देता है।',
      label: '{{name}} की चैट खोलने वाला क्यूआर कोड',
      download: 'क्यूआर कोड डाउनलोड करें',
      downloaded: 'क्यूआर कोड डाउनलोड हो गया।',
      off: 'लिंक चालू होने पर क्यूआर कोड यहाँ दिखेगा।',
    },
    install: {
      noAccess: 'ब्रांड संभालने वाला कोई व्यक्ति ब्रांड और इंस्टॉल से इंस्टॉल कोड कॉपी कर सकता है।',
      guides: 'कोड को अपनी वेबसाइट पर कैसे लगाएँ',
    },
  },
};
